import { TextField } from "@mui/material";

export function IaxDateField({tfonchange, tfvalue, tflabel, tfrequired}) {
  return (
    <TextField
      type="date"
      variant="filled"
      InputLabelProps={{ shrink: true }}
      color="secondary"
      label={tflabel}
      onChange={tfonchange}
      value={tfvalue}
      fullWidth
      required={tfrequired}
      sx={{ mb: 4 }}
    />
  );
}
